import api_escapada_asturias from "@/boot/axios";


// DESDE LA CONFIGURACIÓN DE AXIOS SIEMPRE SE PASA COMO PARÁMETRO EL HASH DE LA WEB.
// SI LA PETICIÓN NO LLEVA PARÁMETROS, EL HASH SE INSERTA DIRECTAMENTE PERO SI LOS LLEVA
// SE INSERTA AL FINAL, COMO ÚLTIMO PARÁMETRO


/**
 * 
 * @returns recupera un listado de jornadas destacadas para la index
 */
export async function get_banda_jornadas_destacadas_index(idIdioma) {
  const url = "/jornadas/get_banda_jornadas_destacadas_index.php?idIdioma=" + idIdioma;
  
  try {
    let { data } = await api_escapada_asturias.get(url);
    return comprobarPeticion(data);
  } catch (error) {
    console.log("ERROR DEL AXIOS", error);
  }
}

export async function get_ficha_jornada(idIdioma, nombre_seo_jornada) {
  const url = "/jornadas/get_jornada.php?idIdioma="+ idIdioma +"&nombre_seo_jornada="+nombre_seo_jornada;
  
  try {
    let { data } = await api_escapada_asturias.get(url);
    
    return comprobarPeticion(data);
  } catch (error) {
    console.error("ERROR DEL AXIOS", error);
    return false;
  }
}





/*
Esta función comprueba que la respuesta que me viene del back de ticbase es coherente con el formato esperado. 
*/
function comprobarPeticion(resultadoPeticion) {
  if (resultadoPeticion.result == "success") {
    return resultadoPeticion;
  } else {
    if (resultadoPeticion.result == "error") {
      return resultadoPeticion;
    } else {
      return {
        result: "error",
        msg: "error no definido",
        data: resultadoPeticion,
      };
    }
  }
}
